import { useMutation } from 'react-query';

import { setVisibilityMode as mutationFn } from 'api/endPoints/setVisibilityMode';

export const useMutationSetVisibilityMode = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    viewId: number;
    hide: boolean;
}
